import React from 'react';
import { Link } from 'react-router-dom';
import { MdErrorOutline } from 'react-icons/md';

const NotFound = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            backgroundColor: '#ffffff',
            color: '#1f2937',
            padding: '2rem'
        }}>
            <div style={{
                maxWidth: '600px',
                width: '100%',
                marginBottom: '2rem'
            }}>
                <img
                    src="/404Page.jpg"
                    alt="404 - Page Not Found"
                    style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '16px',
                        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
                    }}
                />
            </div>
            <h1 style={{
                fontSize: '2.5rem',
                fontWeight: '800',
                color: '#111827',
                marginBottom: '1rem',
                letterSpacing: '-0.025em'
            }}>
                Oops! Page Not Found
            </h1>
            <p style={{
                fontSize: '1.125rem',
                marginBottom: '2.5rem',
                color: '#4b5563',
                maxWidth: '500px',
                lineHeight: '1.6'
            }}>
                It seems you've wandered into unknown territory. The page you're looking for doesn't exist or has been moved.
            </p>
            <Link to="/" style={{
                padding: '0.875rem 2rem',
                backgroundColor: '#4f46e5',
                color: '#fff',
                textDecoration: 'none',
                borderRadius: '10px',
                fontSize: '1rem',
                fontWeight: '600',
                boxShadow: '0 4px 6px -1px rgba(79, 70, 229, 0.2), 0 2px 4px -1px rgba(79, 70, 229, 0.1)',
                transition: 'all 0.2s ease-in-out'
            }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#4338ca';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#4f46e5';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                Return to Safety
            </Link>
        </div>
    );
};

export default NotFound;
